import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const PROJECT_KEY = 'zy_current_project';
const ROLE_KEY = 'zy_current_role';

export default new Vuex.Store({
  state: {
    userId: '1',
    userName: 'admin',
    deptId: '1',
    groupId: '1',
    currentProjectId: localStorage.getItem(PROJECT_KEY) || '',
    currentProjectName: '',
    currentRoleId: localStorage.getItem(ROLE_KEY) || '',
    currentRoleCode: '',
    currentRoleName: '',
    currentDataScope: 'ALL',
    groupLevel: true,
    roles: [],
    /** 当前角色可见菜单 key 集合；null 表示全部可见（超级管理员） */
    menuKeys: null,
    dcPermissions: null,
    dcMenuKeys: null
  },
  mutations: {
    setCurrentProject(state, { id, name }) {
      state.currentProjectId = id;
      state.currentProjectName = name || '';
      if (id) {
        localStorage.setItem(PROJECT_KEY, id);
      } else {
        localStorage.removeItem(PROJECT_KEY);
      }
    },
    setCurrentRole(state, { id, code, name, dataScope, groupLevel }) {
      state.currentRoleId = id;
      state.currentRoleCode = code || '';
      state.currentRoleName = name || '';
      if (dataScope) state.currentDataScope = dataScope;
      if (groupLevel !== undefined) state.groupLevel = groupLevel;
      if (id) {
        localStorage.setItem(ROLE_KEY, id);
      } else {
        localStorage.removeItem(ROLE_KEY);
      }
    },
    setRoles(state, roles) {
      state.roles = roles || [];
    },
    setMenuKeys(state, keys) {
      state.menuKeys = keys;
    },
    setDcScope(state, payload) {
      state.dcPermissions = (payload && payload.permissions) || null;
      state.dcMenuKeys = (payload && payload.menuKeys) || null;
      if (payload && payload.dataScope) state.currentDataScope = payload.dataScope;
    }
  }
});
